<script setup lang="ts">
import PlanetTemperateAnimation from '@/components/Elements/Animations/Planet/Types/PlanetTemperateAnimation.vue'
import PlanetDesertAnimation from '@/components/Elements/Animations/Planet/Types/PlanetDesertAnimation.vue'
import PlanetLavaAnimation from '@/components/Elements/Animations/Planet/Types/PlanetLavaAnimation.vue'
import PlanetGasAnimation from '@/components/Elements/Animations/Planet/Types/PlanetGasAnimation.vue'
import PlanetFerionAnimation from '@/components/Elements/Animations/Planet/Types/PlanetFerionAnimation.vue'
import PlanetIceAnimation from '@/components/Elements/Animations/Planet/Types/PlanetIceAnimation.vue'
import PlanetOceanicAnimation from '@/components/Elements/Animations/Planet/Types/PlanetOceanicAnimation.vue'
import PlanetRingWorldAnimation from '@/components/Elements/Animations/Planet/Types/PlanetRingWorldAnimation.vue'
import PlanetDestroyedAnimation from '@/components/Elements/Animations/Planet/Types/PlanetDestroyedAnimation.vue'

defineProps({
  type: {
    type: Number,
    required: true
  },
  size: {
    type: Number,
    required: true
  }
})

</script>

<template>
  <template v-if="type == 1">
    <PlanetLavaAnimation :size="size"/>
  </template>
  <template v-if="type == 2">
    <PlanetDesertAnimation :size="size"/>
  </template>
  <template v-if="type == 3">
    <PlanetTemperateAnimation :size="size"/>
  </template>
  <template v-if="type == 4">
    <PlanetOceanicAnimation :size="size"/>
  </template>
  <template v-if="type == 5">
    <PlanetGasAnimation :size="size"/>
  </template>
  <template v-if="type == 6">
    <PlanetIceAnimation :size="size"/>
  </template>
  <template v-if="type == 7">
    <PlanetFerionAnimation :size="size"/>
  </template>
  <template v-if="type == 8">
    <PlanetRingWorldAnimation :size="size"/>
  </template>
  <template v-if="type == 9">
    <PlanetDestroyedAnimation :size="size"/>
  </template>
</template>

<style scoped lang="scss">

</style>